<template>
  <div class="manage-guidelines container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">
                  Manage Guidelines
                </h4>
              </div>
            </div>
          </div>
          <div class="manageGuidelinesCard">
            <b-card no-body>
              <b-tabs card class="manageGuidelinesTabs">
                <b-tab
                  title="About Us"
                  active
                  title-link-class="btn btn-bumblebee btn-mid btn-tab btn-mid-tab-border-bottom"
                >
                  <EditTextBlock
                    type="about_us"
                    subtitle="About Us"
                    :value="about_us_text"
                    :id="about_us_id"
                    :slug="about_us_slug"
                  />
                </b-tab>
                <b-tab
                  title="Terms and Conditions"
                  title-link-class="btn btn-bumblebee btn-mid btn-tab  btn-mid-tab-border-bottom"
                >
                  <EditTextBlock
                    type="terms"
                    :subtitle="'Terms and Conditions'"
                    :value="terms_text"
                    :id="terms_id"
                    :slug="terms_slug"
                  />
                </b-tab>
                <b-tab
                  title="Privacy Policy"
                  title-link-class="btn  btn-bumblebee btn-mid btn-tab btn-mid-tab-border-bottom"
                >
                  <EditTextBlock
                    type="privacy"
                    :subtitle="'Privacy Policy'"
                    :value="privacy_text"
                    :id="privacy_id"
                    :slug="privacy_slug"
                  />
                </b-tab> </b-tabs
            ></b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditTextBlock from "./EditTextBlock.vue";

import axios from "axios";
import $ from "jquery";

export default {
  name: "ManageGuidelines",
  components: { EditTextBlock },
  data() {
    return {
      client_name:"MID",
      
      about_us_id: null,
      about_us_slug:"about-us",
      about_us_text: "",

      terms_id: null,
      terms_slug:"terms-conditions",
      terms_text: "",

      privacy_id: null,
      privacy_slug:"privacy-policy",
      privacy_text: "",
      // about_us_text:"About MyIrishDate! \n"+
      //                 "These terms and conditions outline the rules and regulations for the use of Company Name's Website, located at Website.com. \n"+
      //                 "By accessing this website we assume you accept these terms and conditions. Do not continue to use Website Name if you do not agree to take all of the terms and conditions stated on this page.  \n"+
      //                 "The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: “Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company's terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of provision of the Company's stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.",
      // terms_text:"Welcome to MyIrishDate!  \n "+
      //                 "These terms and conditions outline the rules and regulations for the use of Company Name's Website, located at Website.com.  \n"+
      //                 "By accessing this website we assume you accept these terms and conditions. Do not continue to use Website Name if you do not agree to take all of the terms and conditions stated on this page.  \n"+
      //                 "The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: “Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company's terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of provision of the Company's stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.",
      // privacy_text:"Privacy Policy MyIrishDate!  \n "+
      //                 "These terms and conditions outline the rules and regulations for the use of Company Name's Website, located at Website.com.  \n"+
      //                 "By accessing this website we assume you accept these terms and conditions. Do not continue to use Website Name if you do not agree to take all of the terms and conditions stated on this page.  \n"+
      //                 "The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: “Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company's terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of provision of the Company's stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      console.log("in get data - mange guidelines")
      axios
        .get("cms/admin/cms-pages", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.data);
          let guidelinesList = response.data.data;
          for (let index in guidelinesList) {
            console.log(guidelinesList[index]);
            if (guidelinesList[index].slug == "about-us") {
              this.about_us_text = guidelinesList[index].text;
              this.about_us_id = guidelinesList[index].id;
            }
            else if(guidelinesList[index].slug == "terms-conditions"){
              this.terms_text = guidelinesList[index].text;
              this.terms_id = guidelinesList[index].id
            }
            else if(guidelinesList[index].slug == "privacy-policy"){
              this.privacy_text = guidelinesList[index].text;
              this.privacy_id = guidelinesList[index].id
            }
          }
        })
        .catch((error) => {
          // console.log(error.response);
          // this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/manage_guidelines/Index.vue